'use strict';
var _ = require('lodash');
var Backbone = require('backbone');
var template = require('../../templates/loading.ejs');

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-loading',
    /**
     * Initialize Loading View
     */
    initialize: function () {
        _.bindAll(this, 'render');
    },
    /**
     * Render Loading View
     */
    render: function () {
        this.$el.html(template(this.model));
        return this;
    }
});



// WEBPACK FOOTER //
// ./app/scripts/common/views/loading.js